module.exports = __webpack_public_path__ + "static/media/spain-flag.31fce790.png";